<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- latest transactions -->
        <div class="is-flex section-title bg-tx">
          <h2 class="has-text-info is-marginless">{{ $t("res.latest_transactions") }}</h2>
        </div>
        <ticker-transaction-table v-bind:transactions="transactions"></ticker-transaction-table>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
  import TickerTransactionTable from '../components/layout/TickerTransactionTable'

  export default {
    name: 'Ticker',
    components: {TickerTransactionTable},
    computed: {
      transactions () {
        return this.$store.state.chainStatus.latestTransactions.slice(0, 20)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    min-height: 77vh;
  }

  .bg-tx {
    background-image: url("../assets/tx_bg.png");
    background-repeat: no-repeat;
  }

  .section-title {
    padding-top: 1rem;
    margin-bottom: 1rem;
    align-items: flex-end;

    h2 {
      padding-left: 4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Ticker.vue